import useLocalStorage from 'services/data-handler-services/web-storage-service/local-storage-service';
import MemoryStorageService from 'services/data-handler-services/web-storage-service/memory-storage-service';
import useSessionStorage from 'services/data-handler-services/web-storage-service/session-storage-service';

const LOCAL_STORAGE = 'localStorage';
const SESSION_STORAGE = 'sessionStorage';
const MEMORY_STORAGE = 'memoryStorage';
let webStorage = null;

const checkStorage = function (storageName) {
  try {
    const storage = window[storageName];
    storage.setItem('ls-support', 1);
    storage.removeItem('ls-support');
    return true;
  } catch (e) {
    /**
     * TODO: 1. Warn user to use non-private mode if possible (a toaster or fading alert). 2. Recover from QUOTA_EXCEEDED_ERR
     * https://developer.apple.com/library/archive/documentation/iPhone/Conceptual/SafariJSDatabaseGuide/Name-ValueStorage/Name-ValueStorage.html
     *
     */

    console.warn(`${storageName} is unavailable`, e);
    return false;
  }
};

const isSupported = (storage = LOCAL_STORAGE) => {
  if (storage === LOCAL_STORAGE || storage === SESSION_STORAGE) {
    return checkStorage(storage);
  } else if (storage === MEMORY_STORAGE) {
    return true;
  } else {
    throw new Error(`${storage} name not supported. `);
  }
};

/**
 * Use a fallback if localStorage or sessionStorage are not supported
 */
const LocalStorageService = isSupported(LOCAL_STORAGE) ? useLocalStorage : MemoryStorageService;

/**
 * Note: Data in sessionStorage is cleared when the page session ends.
 * A page session lasts as long as the browser is open, and survives over page reloads and restores.
 * https://developer.mozilla.org/en-US/docs/Web/API/Window/sessionStorage
 */
const SessionStorageService = isSupported(SESSION_STORAGE) ? useSessionStorage : MemoryStorageService;

/**
 * Use webStorage if it doesn't really matter what storage to use,
 */
if (isSupported(LOCAL_STORAGE)) {
  webStorage = useLocalStorage;
} else if (isSupported(SESSION_STORAGE)) {
  webStorage = useSessionStorage;
} else {
  webStorage = MemoryStorageService;
}

/**
 * Extra precaution to Shim local storage for
 * `DOMException: Failed to read the 'localStorage' property from 'Window': Access is denied for this document` error
 */
if (!isSupported(LOCAL_STORAGE)) {
  Object.defineProperty(window, 'localStorage', {
    value: webStorage,
    configurable: true,
    enumerable: true,
    writable: true,
  });
}

export { webStorage, checkStorage, LocalStorageService, MemoryStorageService, SessionStorageService };
